module.exports = "https://beta.voredev.ru/assets/index/avito-mini-3e1323e62ba47a2252b4af15dcbb9653.svg";